var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7109 13.2646C38.8663 11.5102 37.4839 10 35.7226 10H10.5794C9.02513 10 7.72822 11.1872 7.59114 12.7354L5.28905 38.7354C5.13371 40.4898 6.51607 42 8.27736 42H33.4206C34.9749 42 36.2718 40.8128 36.4089 39.2646L38.7109 13.2646Z",
    fill: "#111B48",
    stroke: "#111B48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2891 13.2646C10.1337 11.5102 11.5161 10 13.2774 10H38.4206C39.9749 10 41.2718 11.1872 41.4089 12.7354L43.7109 38.7354C43.8663 40.4898 42.4839 42 40.7226 42H15.5794C14.0251 42 12.7282 40.8128 12.5911 39.2646L10.2891 13.2646Z",
    fill: "white",
    stroke: "#111B48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 25.5L27 30.5L34.5 20.5",
    stroke: "#111B48",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5C13.5 7.567 14.8431 6 16.5 6C18.1569 6 19.5 7.567 19.5 9.5C19.5 11.1185 18.5583 12.4805 17.2793 12.8808",
    stroke: "#111B48",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.5C19.5 7.567 20.8431 6 22.5 6C24.1569 6 25.5 7.567 25.5 9.5C25.5 11.1185 24.5583 12.4805 23.2793 12.8808",
    stroke: "#111B48",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 9.5C25.5 7.567 26.8431 6 28.5 6C30.1569 6 31.5 7.567 31.5 9.5C31.5 11.1185 30.5583 12.4805 29.2793 12.8808",
    stroke: "#111B48",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 9.5C31.5 7.567 32.8431 6 34.5 6C36.1569 6 37.5 7.567 37.5 9.5C37.5 11.1185 36.5583 12.4805 35.2793 12.8808",
    stroke: "#111B48",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingComments);
export default __webpack_public_path__ + "static/media/PendingComments.481b8d2cd3c64e1860c56e6eaefadc6e.svg";
export { ForwardRef as ReactComponent };